import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/Catalog.ts
var n = class n extends t {
	static {
		this.baseCatalogUrl = `/rest/organizations/${e.orgPlaceholder}/catalogs`;
	}
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/catalog-management/catalogs/fields`;
	}
	getFields(e) {
		return this.api.post(n.baseUrl, e);
	}
	listCatalogsByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseCatalogUrl}/project`, {
			...t,
			projectId: e
		}));
	}
};
//#endregion
export { n as Catalog };

//# sourceMappingURL=Catalog.js.map